import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ConfirmAlertComponent } from '../view/components/confirm-alert/confirm-alert.component';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(
    private d: MatDialog
  ) { }

  confirm(msg: string) {
    const dref = this.d.open(
      ConfirmAlertComponent,
      {
        data: msg,
        backdropClass: 'custom-backdrop-alertservice'
      }
    );
    return dref.afterClosed();
  }
}
